import { toast } from '@/ui'
import { useTranslation } from 'react-i18next'
import { useMemo, useEffect, type ReactNode } from 'react'

import { useRouter, usePermissionCheck } from '@/hooks'
import type { Permission } from '@/types/Permission'

const AuthRoute = ({
  permissions,
  children,
}: {
  permissions?: Permission[]
  children: ReactNode | (() => ReactNode)
}) => {
  const { t } = useTranslation()
  const { navigate } = useRouter()
  const { hasPermissions, loading } = usePermissionCheck()
  const canViewPage = useMemo(
    () => hasPermissions(permissions),
    [hasPermissions, permissions],
  )

  useEffect(() => {
    if (!loading && !canViewPage) {
      toast.error(t('You do not have access to view this page'))
      navigate(-1)
    }
  }, [loading, canViewPage]) // eslint-disable-line

  if (loading || !canViewPage) {
    return null
  }

  return <>{typeof children === 'function' ? children() : children}</>
}

export default AuthRoute
